import React, { useCallback, useState } from 'react';
import { ScrollView } from 'react-native';
import styled from '@emotion/native';

import {
  Header,
  MainSurface,
  ScreenLayout,
  ScreenLoader,
} from '@appComponents/ScreenLayout';
import { useTrip } from '@appUtils/manager';
import Tabs from '@appComponents/Tabs';
import TripDetails from './TripDetails';
import TripExpenses from './TripExpenses';
import { PostFlightTab } from '../PostFlight/PostFlightTab';
import { MeteringTab } from '../Metering/MeteringTab';
import { MeteringProvider } from '@appUtils/context/MeteringContext';

const Trip = ({ route, navigation }) => {
  const documentPath = route.params.documentPath;
  const { loading, data: trip, save, update } = useTrip(documentPath);
  const edit = useCallback(
    () => navigation.navigate('Trip Builder', { documentPath }),
    [documentPath, navigation],
  );

  const [activeTab, setActiveTab] = useState(
    route.params?.tab ?? TripDetailsTab.TRIP,
  );

  return (
    <ScreenLayout alignItems="stretch">
      <TripInfoHeader>
        <TripTabs activeTab={activeTab} onChange={setActiveTab} />
      </TripInfoHeader>
      <MainSurface>
        <ScrollView>
          {loading && <ScreenLoader />}
          {!loading && activeTab === TripDetailsTab.TRIP && (
            <Details trip={trip} save={save} update={update} onEdit={edit} />
          )}
          {!loading && activeTab === TripDetailsTab.EXPENSES && (
            <TripExpenses trip={trip} save={save} update={update} />
          )}
          {!loading && activeTab === TripDetailsTab.POSTFLIGHT && (
            <PostFlightTab trip={trip} documentPath={documentPath} />
          )}
          {!loading && activeTab === TripDetailsTab.METERING && (
            <MeteringProvider>
              <MeteringTab trip={trip} documentPath={documentPath} />
            </MeteringProvider>
          )}
        </ScrollView>
      </MainSurface>
    </ScreenLayout>
  );
};

export const TripDetailsTab = {
  TRIP: 'TRIP INFO',
  // AIRCRAFT: 'AIRCRAFT INFO',
  // SQUAWKS: 'SQUAWKS',
  METERING: 'METERING',
  POSTFLIGHT: 'POST FLIGHT',
  EXPENSES: 'EXPENSES',
};

const getTripRoutes = () => [
  { key: 'trip', title: TripDetailsTab.TRIP },
  { key: 'expenses', title: TripDetailsTab.EXPENSES },
  // { key: 'aircraft', title: TripTab.AIRCRAFT },
  // { key: 'squawks', title: TripTab.SQUAWKS },
  { key: 'metering', title: TripDetailsTab.METERING },
  { key: 'postflight', title: TripDetailsTab.POSTFLIGHT },
];

const TripTabs = ({ activeTab, onChange }) => {
  const [routes] = useState(getTripRoutes);
  const handleChange = useCallback(
    ({ route }) => onChange(route.title),
    [onChange],
  );

  return (
    <Tabs
      tabIndex={routes.findIndex(tab => tab.title === activeTab)}
      onTabPress={handleChange}
      routes={routes}
      tabBarInline
    />
  );
};

const TripInfoHeader = styled(Header)`
  padding-bottom: 0;
`;

const Details: typeof TripDetails = styled(TripDetails)(({ theme }) => ({
  paddingHorizontal: '5%',
  paddingVertical: theme.layout.space(2),
}));

export default Trip;
